module.exports = __webpack_public_path__ + "static/media/chevron-double-right.45f36057.svg";